import { PlatformIcon } from "@/components/PlatformBadge";
import { fmtCompact } from "@/lib/format";
import { TrendingUp } from "lucide-react";

export default function Glance({ glance }) {
  if (!glance) return null;
  return (
    <section data-testid="glance-section" className="overflow-hidden rounded-3xl border border-border/60 bg-brand-primary text-brand-primary-foreground shadow-sm">
      <div className="grid gap-6 p-6 sm:p-8 lg:grid-cols-[1.2fr_1fr] lg:items-center">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] opacity-70">Your marketing at a glance</p>
          <div className="mt-3 flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-white/15">
              <PlatformIcon platform={glance.channel} className="h-5 w-5" withColor={false} />
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight sm:text-3xl">{glance.headline}</h2>
          </div>
          <div className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-sm font-semibold">
            <TrendingUp className="h-4 w-4" /> +{glance.delta}% engagement vs previous period
          </div>
        </div>
        <div className="flex gap-3">
          {glance.posts?.slice(0, 3).map((p) => (
            <div key={p.post_id} className="relative flex-1 overflow-hidden rounded-2xl">
              <img src={p.thumbnail_url} alt={p.caption} className="aspect-[3/4] h-full w-full object-cover" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-2 pt-6">
                <p className="text-xs font-bold text-white">{fmtCompact(p.engagement)}</p>
                <p className="text-[10px] text-white/70">engagement</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
